import React from "react";
import Logo from "../../components/common/Logo";

function TermsOfUse() {
  return (
    <div className="min-h-screen bg-[#F4EFE8] flex flex-col">

      {/* Main Content */}
      <main className="flex-1 px-4 sm:px-6 md:px-10 lg:px-16 py-6 sm:py-8">

        {/* Logo */}
        <div className="mb-6 sm:mb-8">
          <Logo />
        </div>

        {/* Top Bar */}
        <div className="bg-[#3f35c7] rounded-xl min-h-[60px] sm:min-h-[70px] flex items-center px-5 sm:px-6 md:px-8">
          <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold">
            Terms of Use
          </h2>
        </div>

        {/* Content */}
        <div className="w-full max-w-[1400px] mx-auto mt-10 sm:mt-12 md:mt-16">

          {/* Title */}
          <div className="text-center px-2 sm:px-6">

            <h1 className="text-[#3f35c7] text-2xl sm:text-3xl md:text-4xl font-bold">
              Terms of Use
            </h1>

            <p className="mt-4 sm:mt-5 text-[#7A6D79] text-sm sm:text-base md:text-lg lg:text-xl max-w-[1000px] mx-auto leading-7 sm:leading-8">
              Reference site about Lorem Ipsum, giving information on its
              origins, as well as a random.
            </p>

          </div>

          {/* Effective Date */}
          <div className="flex justify-start sm:justify-end mt-10 sm:mt-14 md:mt-20">
            <p className="text-[#202020] text-sm sm:text-base md:text-lg font-semibold">
              Effective date: August 1, 2021
            </p>
          </div>

          {/* Introduction */}
          <section className="mt-10 sm:mt-14 md:mt-16">

            <h2 className="text-[#202020] text-lg sm:text-xl md:text-2xl font-bold uppercase mb-4 sm:mb-6">
              Introduction
            </h2>

            <p className="text-[#2D2D2D] text-sm sm:text-base md:text-lg leading-7 md:leading-8">
              We are committed to respecting your online privacy and recognize
              your need for appropriate protection and management of any
              personally identifiable information (“Personal Information”) you
              share with us. “Personal Information” means any information that
              may be used, either alone or in combination with other information,
              to personally identify an individual, including, but not limited
              to, a first and last name, personal profile, a home or other
              physical address, an email address or other contact information.
            </p>

          </section>

          {/* User Responsibilities */}
          <section className="mt-12 sm:mt-16 md:mt-20">

            <h2 className="text-[#202020] text-lg sm:text-xl md:text-2xl font-bold uppercase mb-4 sm:mb-6">
              User Responsibilities
            </h2>

            <p className="text-[#2D2D2D] text-sm sm:text-base md:text-lg leading-7 md:leading-8">
              Users are responsible for maintaining the confidentiality of
              their login credentials and ensuring that all activities
              performed through their account comply with platform policies.
              Misuse of the platform, unauthorized sharing of content, or
              disruptive behavior may lead to suspension or permanent
              termination of access.
            </p>

          </section>

          {/* Privacy Policy */}
          <section className="mt-12 sm:mt-16 md:mt-20 mb-12 sm:mb-16 md:mb-20">

            <h2 className="text-[#202020] text-lg sm:text-xl md:text-2xl font-bold uppercase mb-4 sm:mb-6">
              Privacy Policy
            </h2>

            <p className="text-[#2D2D2D] text-sm sm:text-base md:text-lg leading-7 md:leading-8">
              We value your privacy and take necessary steps to protect your
              personal information. Information collected through the platform
              is used solely for educational, analytical, and support purposes.
              We do not sell or distribute your data to third parties without
              your consent unless required by law.
            </p>

          </section>

        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-[#DED7CB] mt-auto">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-10 py-5 sm:py-6">

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-sm sm:text-base text-[#5144C8]">

            <a
              href="/terms-condition"
              className="hover:underline transition"
            >
              Terms of use
            </a>

            <a
              href="/policy"
              className="hover:underline transition"
            >
              Privacy policy
            </a>

            <span className="text-[#8B8190]">
              © 2026
            </span>

          </div>

        </div>
      </footer>

    </div>
  );
}

export default TermsOfUse;